import React, { useCallback, useState } from 'react'
import styled from 'styled-components/macro';
import { useParams } from 'react-router-dom';
import { Icon, Button, Title } from 'components/atoms'
import { FileSelect } from 'containers'
import PropTypes from 'prop-types'
import { useToggle } from 'hooks'
import { Modal } from 'components/molecules';
import { insertBlock, insertBlockUrl, insertLink } from 'services/helpers'

export const RichTextEditorOptionFile = ({
  onChange,
  editorState,
  initialValues,
}) => {
  const acess = false;
  const [isOpen, toggle] = useToggle(false)
  const [values, setValues] = useState()
  const { subweb, lang } = useParams();

  const onDiscard = () => {
    toggle()
  }
  const handleClickAdd = (rec) => {
    const { title, id } = rec;
    const url = `https://www.ua.pt/file/${id}`;
    const props = {
      title,
      id,
      url
    }
    insertLink(editorState, onChange, { type: 'LINK', data: props });
    toggle()
  }

  const memoizedTeste = useCallback(handleClickAdd, [onChange, editorState, isOpen]);

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle}>
        <Title>Copiar Ficheiro</Title>
        <FileSelect teste={memoizedTeste} rteofile={acess} lang={lang} subweb={subweb} />
        <Actions>
          <Button
            type="button"
            modifiers={['marginRight', 'capitalize']}
            onClick={onDiscard}
          >
              Voltar
          </Button>
        </Actions>
      </Modal>
      <Option onClick={toggle}>
        <Icon icon="fal fa-file" height={16} />
      </Option>
    </>
  )
}

const Option = styled.div`
    padding: ${props => props.theme.spacing.xs2};
    border-radius: 2px;
    margin: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background: ${props => props.theme.colors.bgLighterS};
    text-transform: capitalize;
    &:hover {
      background-color: #eee;
    }
`
const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: ${props => props.theme.spacing.l};
`;

RichTextEditorOptionFile.propTypes = {
  onChange: PropTypes.func.isRequired,
  editorState: PropTypes.shape({}).isRequired,
  initialValues: PropTypes.shape({}),
}

RichTextEditorOptionFile.defaultProps = {
  initialValues: {}
}


export default RichTextEditorOptionFile
